import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'Components';
import { AppContext, AuthContext } from 'Context';
import { Pathname } from 'Routes';
import { encryptedKeyForCredentials } from 'Commons';
import { axios, baseUrl } from 'Api';
import styles from './index.module.css';
import Apple from '../../../../Assets/apple.svg';

function AppleLogin({ loginWithSocial }) {
  const navigate = useNavigate();
  const {
    setAppSnackbar,
    setUserDetails,
    fetchData,
    setReferralStatus,
    setPlansPage,
    setFromLogin,
  } = useContext(AppContext);
  const {
    setToken,
    setEmailVerified,
    forceAutoSignin,
    setPreferredEmail,
  } = useContext(AuthContext);

  useEffect(() => {
    // Get the current origin dynamically
    const currentOrigin = window.location.origin;
    const redirectURI = `${currentOrigin}/access`;
    // Define handlers before init
    const handleAppleSignInSuccess = async (event) => {
      const { authorization, authorizedData } = event.detail || {};
      if (!authorization) {
        console.error('No authorization data received');
        return;
      }
          loginWithSocial(authorization.id_token, 'Apple');
      // Process the login
      try {
        // call BE API with data
      } catch (error) {
        console.error('Login processing failed:', error);
      }
    };

    const handleAppleSignInFailure = (event) => {
      console.error('Apple Sign-In failed', event);
      console.error('Failure detail:', event.detail);
      setAppSnackbar({
        type: 'error',
        message: 'Apple sign-in failed. Please try again.',
        isVisible: true,
      });
    };

    // Handle messages from popup window
    const handleMessage = async (event) => {
      // Verify origin
      if (event.origin !== window.location.origin) {
        console.log('Message from different origin, ignoring');
        return;
      }
      if (event.data.type === 'apple-signin-success') {
        const { authorization, authorizedData } = event.data.detail || {};
        if (authorization) {
          try {
            // call BE API with data
          } catch (error) {
            console.error('Login processing failed:', error);
          }
        }
      } else if (event.data.type === 'apple-signin-failure') {
        console.error('Apple Sign-In failed from popup:', event.data.detail);
        setAppSnackbar({
          type: 'error',
          message: 'Apple sign-in failed. Please try again.',
          isVisible: true,
        });
      }
    };
    // Add listeners
    document.addEventListener('AppleIDSignInOnSuccess', handleAppleSignInSuccess);
    document.addEventListener('AppleIDSignInOnFailure', handleAppleSignInFailure);
    window.addEventListener('message', handleMessage);
    // Initialize Apple ID auth
    if (window.AppleID && window.AppleID.auth) {
      window.AppleID.auth.init({
        clientId: 'app.projector.stream',
        scope: 'name email',
        redirectURI,
        usePopup: true,
      });
      console.log('Apple ID auth initialized');
    } else {
      console.error('AppleID.auth not available');
    }
    return () => {
      document.removeEventListener('AppleIDSignInOnSuccess', handleAppleSignInSuccess);
      document.removeEventListener('AppleIDSignInOnFailure', handleAppleSignInFailure);
      window.removeEventListener('message', handleMessage);
    };
  }, [setAppSnackbar]);
  const handleAppleSignIn = async () => {
    console.log('Apple Sign In button clicked');
    try {
      if (window.AppleID && window.AppleID.auth) {
        console.log('Calling AppleID.auth.signIn()');
        // Store the current time to detect when popup closes
        const startTime = Date.now();
        let popupClosed = false;
        // Start checking if popup closed
        const checkInterval = setInterval(() => {
          // Check if more than 1 second has passed and we haven't received events
          if (Date.now() - startTime > 1000 && !popupClosed) {
            // Check if there's any Apple response in session/local storage
            // This is a fallback in case events don't fire
            const appleResponse = sessionStorage.getItem('apple_signin_response');
            if (appleResponse) {
              try {
                const response = JSON.parse(appleResponse);
                console.log('Found Apple response in session storage:', response);
                sessionStorage.removeItem('apple_signin_response');
                if (response.authorization) {
                  // call BE API with data
                }
              } catch (e) {
                console.error('Error parsing Apple response:', e);
              }
            }
          }
          // Stop checking after 30 seconds
          if (Date.now() - startTime > 30000) {
            clearInterval(checkInterval);
          }
        }, 500);
        await window.AppleID.auth.signIn();
        // Clear the interval when sign in completes or fails
        setTimeout(() => {
          popupClosed = true;
          clearInterval(checkInterval);
        }, 1000);
      } else {
        console.error('AppleID.auth not available');
        setAppSnackbar({
          type: 'error',
          message: 'Apple Sign-In is not properly initialized. Please refresh and try again.',
          isVisible: true,
        });
      }
    } catch (error) {
      console.error('Error triggering Apple Sign-In:', error);
    }
  };
  return (
    <Button
      isGrayWhiteText
      isFullWidth
      alignCenter
      blockText
      onClick={handleAppleSignIn}
      type="button"
    >
      <img className={styles.buttonLogoGoogle} src={Apple} alt="Apple" />
      Continue with Apple
    </Button>
  );
}
export default AppleLogin;
